import { useState, useEffect } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import useTranslator from "../../../hooks/useTranslator";
import { getCurrentDate } from "../../../helpers/Utils";

const initialFormData = {
  date: "",
};

const GasConsumptionFilter = ({ onApplyFilter, onClose, filters = {} }) => {
  const [filtersData, setFiltersData] = useState({
    date: filters.date || "",
  });

  const { _t } = useTranslator();

  useEffect(() => {
    setFiltersData({ date: filters.date || "" });
  }, [filters.date]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFiltersData({ ...filtersData, [name]: value });
  };

  const handleReset = (e) => {
    e.preventDefault();
    setFiltersData(initialFormData);
    onApplyFilter(initialFormData);
    if (onClose) onClose();
  };

  const handleApply = (e) => {
    e.preventDefault();
    onApplyFilter({ ...filtersData });
    if (onClose) onClose();
  };

  return (
    <div className="dropdown_body">
      <h5 className="mb-3 border-bottom">{_t("filter_heading", "Filter")}</h5>

      <InputWithLabel
        label={_t("entered_date", "Entered Date")}
        type="date"
        name="date"
        value={filtersData.date}
        onChange={handleChange}
        max={getCurrentDate("YYYY-MM-DD")}
      />

      <div className="d-flex justify-content-between mt-3">
        <Button
          onClick={handleReset}
          label={_t("reset_button", "Reset")}
          className="reset_btn"
        />
        <Button
          className="cmn_btn"
          label={_t("apply_button", "Apply")}
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default GasConsumptionFilter;
